<div class="w-full md:items-center flex gap-x-2 justify-between md:justify-end">
  @if (platform.isBrowser) {
    <span class="text-nowrap text-sm italic" i18n>Share on:</span>
    <share-buttons
      [theme]="'modern-dark'"
      [include]="['linkedin','xing', 'facebook','twitter','whatsapp','reddit','telegram','messenger','email']"
      [autoSetMeta]="autoSetMeta"
      [title]="title"
      [description]="description"
      [image]="image"
      [url]="url"
      [show]="show">
    </share-buttons>
  }
</div>


